import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { getAuthHeaders } from '../../utils/api';
import { Box } from '@mui/material';
import LogTheme from './LogTheme';

function YearLogs() {
  const [logs, setLogs] = useState([]);
  const { year } = useParams();
  const { userId } = useAuth();

  useEffect(() => {
    fetch(`${process.env.REACT_APP_SERVER_URL}/api/logs/${year}`, {
      method: 'GET',
      headers: getAuthHeaders(),
    })
      .then((response) => response.json())
      .then((data) => setLogs(data))
      .catch((error) => console.error('Error fetching logs:', error));
  }, [year, userId]);

  return (
    <LogTheme>
      <Box sx={{ maxWidth: '1200px', margin: '0 auto', padding: { xs: 2, md: 4 } }}>
        <h1>Loggar för {year}</h1>
        {logs.map((log, index) => (
          <div key={index}>
            {/* Rendera din loggdata här */}
            <p>{log.title}</p>
            <p>{log.content}</p>
          </div>
        ))}
      </Box>
    </LogTheme>
  );
}

export default YearLogs;